module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/oranges@2x_0a28f1.jpg";